import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../../hooks'
import { isAdminUser, isStaffUser } from '../../../../utils/user'
import { FormikForm } from '../../../Formik'
import { getValidationSchema } from '../../NewsboardPostForm'
import {
  getAudienceModalInitialValues,
  getAudiencePayload,
} from '../NewsboardPostProfileWidgetAudience.utils'
import { NewsboardPostProfileWidgetAudienceFormFields } from '../NewsboardPostProfileWidgetAudienceFormFields'

function NewsboardPostProfileWidgetAudienceForm({
  postData,
  onCancel,
  onSubmit,
  onSuccess,
}) {
  const { t } = useTranslation()

  const user = useUserData()
  const isStaffUserAcc = isStaffUser(user)
  const isAdmin = isAdminUser(user)

  const ticker = postData?.isTvTicker

  const initialValues = getAudienceModalInitialValues(postData, t)

  async function handleSubmit(values, formikHelpers) {
    try {
      await onSubmit(
        getAudiencePayload(values, { isAdmin, isStaff: isStaffUserAcc })
      )

      onSuccess?.()
    } finally {
      formikHelpers.setSubmitting(false)
    }
  }

  return (
    <FormikForm
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getValidationSchema({
        initialValues,
        isStaffUserAcc,
      })}
      onSubmit={handleSubmit}
    >
      <NewsboardPostProfileWidgetAudienceFormFields
        isStaffUserAcc={isStaffUserAcc}
        ticker={ticker}
        onCancel={onCancel}
      />
    </FormikForm>
  )
}

export default NewsboardPostProfileWidgetAudienceForm
